import { render, staticRenderFns } from "./FooterButton.vue?vue&type=template&id=5ff62b50&scoped=true&"
import script from "./FooterButton.vue?vue&type=script&lang=js&"
export * from "./FooterButton.vue?vue&type=script&lang=js&"
import style0 from "./FooterButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FooterButton.vue?vue&type=style&index=1&id=5ff62b50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff62b50",
  null
  
)

export default component.exports